const packBuilderIntroModalStyles = () => ({
  content: {
    width: '1200px',
    height: '684px'
  },
  dialogModal: {
    borderRadius: '5px'
  },
  container: {
    height: '100%'
  },
  gridWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    height: '100%'
  },
  leftSection: {
    flex: 1,
    textAlign: 'center',
    paddingRight: 20
  },
  stepImage: {
    width: 500,
    objectFit: 'contain'
  },
  rightSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    gap: '20px',
    padding: '40px'
  },
  stepNumber: {
    fontWeight: '500',
    fontSize: '32px',
    lineHeight: '123%',
    letterSpacing: '-1px',
    verticalAlign: 'middle',
    color: '#0059FF'
  },
  stepNumberCircle: {
    border: '2px solid #0065FF',
    width: '54px',
    height: '54px',
    borderRadius: '27px',
    borderWidth: '2px',
    paddingTop: '6px',
    paddingRight: '18px',
    paddingBottom: '6px',
    paddingLeft: '18px',
    gap: '10px'
  },
  input: {
    width: '100%',
    padding: '10px 12px',
    fontSize: 16,
    borderRadius: 8,
    border: '1px solid #ccc',
    fontFamily: 'Inter, sans-serif'
  },
  buttonGroup: {
    display: 'flex',
    justifyContent: 'flex-start',
    gap: 12
  },
  primaryButton: {
    backgroundColor: '#000',
    width: 134,
    color: '#fff',
    borderRadius: 4,
    padding: '20px 20px',
    height: 44,
    fontWeight: 500,
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#111'
    }
  },
  linkButton: {
    height: '48px',
    borderRadius: 4,
    gap: 10,
    color: '#2663FF',
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: 16,
    lineHeight: '16px',
    letterSpacing: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'none',
    textDecoration: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    boxShadow: 'none',
    marginTop: 16,
    '&:hover': {
      backgroundColor: 'rgba(237, 96, 45, 0.1)'
    }
  },
  continueButton: {
    background: '#131415',
    color: '#fff',
    width: 134,
    padding: '6px 16px',
    height: 48,
    borderRadius: '4px',
    minWidth: 'unset',
    gap: '10px',
    '&:hover': {
      background: '#19191a'
    }
  },
  buttonText: {},
  iconCircle: {
    backgroundColor: '#fff',
    color: '#000',
    borderRadius: '50%',
    width: 16,
    height: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 16
  },
  rightSectionWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: 520,
    height: '100%',
    gap: '40px'
  },
  modalContentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    height: '100%'
  },
  progressBar: {
    marginTop: 'auto'
  }
});

export default packBuilderIntroModalStyles;
